<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>运单查询</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class=" inpBox">
          <el-form-item label="运单编号:" prop="waybillNo">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.waybillNo"></el-input>
      </el-form-item>
      <el-form-item label="疏港计划号:" prop="planNo">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.planNo"></el-input>
      </el-form-item>
      <el-form-item label="采购订单号:" prop="purorderNo">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.purorderNo"></el-input>
      </el-form-item>
      <el-form-item label="日计划号:" prop="purplanNo">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.purplanNo"></el-input>
      </el-form-item>
      <el-form-item label="车队:" prop="fleetId">
        <el-select v-model="searchFrom.fleetId" placeholder="请选择">
          <el-option
            v-for="(item,index) in fleetOptions"
            :key="index"
            :label="item.fleetName"
            :value="item.fleet">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="车牌号:" prop="vehicleNo">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.vehicleNo"></el-input>
      </el-form-item>
      <el-form-item label="司机:" prop="driverName">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.driverName"></el-input>
      </el-form-item>
      <el-form-item label="电话:" prop="driverMobile">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.driverMobile"></el-input>
      </el-form-item>
      <el-form-item label="物料名称:" prop="goodsName">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.goodsName"></el-input>
      </el-form-item>
      <el-form-item label="港口:" prop="wharfId">
        <el-select v-model="searchFrom.wharfId" placeholder="请选择" @change="portOptionChangeDialog">
          <el-option
            v-for="(item,index) in portOptions"
            :key="index"
            :label="item.showName"
            :value="item.itemNo">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="码头:" prop="wharfxId">
        <el-select v-model="searchFrom.wharfxId" placeholder="请选择" @change="wharfxIdChange()">
          <el-option
            v-for="(item,index) in wharfOptions"
            :key="index"
            :label="item.showName"
            :value="item.itemNo">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="码头场区:" prop="areaName">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.areaName"></el-input>
      </el-form-item>
      <el-form-item label="收货仓库:" prop="warehouseName">
        <el-select v-model="searchFrom.warehouseName" placeholder="请选择">
          <el-option
            v-for="(item,index) in receivingWarehouseOptions"
            :key="index"
            :label="item.plantName"
            :value="item.plantName">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="运单状态:" prop="waybillStatus">
        <el-select v-model="searchFrom.waybillStatus" placeholder="请选择">
          <el-option
            v-for="(item,index) in waybillStatusOptions"
            :key="index"
            :label="item.showName"
            :value="item.itemNo">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="派车时间:" prop="startTime">
        <el-date-picker
          v-model="searchFrom.startTime"
          size="mini"
          @change="startTimeChangeA"
          :editable="false"
          style="width: 190px"
          placeholder="选择日期"
          :clearable="false"
          type="datetime"
        ></el-date-picker>&nbsp;-&nbsp;&nbsp;
        <el-date-picker
          v-model="searchFrom.endTime"
          @change="startTimeChangeB"
          :clearable="false"
          :editable="false"
          size="mini"
          style="width: 190px"
          placeholder="选择日期"
          type="datetime"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="超限标记:" prop="overrunFlag">
        <el-select v-model="searchFrom.overrunFlag" placeholder="请选择">
          <el-option
            v-for="(item,index) in overrunMarkOptions"
            :key="index"
            :label="item.showName"
            :value="item.itemNo">
          </el-option>
        </el-select>
      </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" @click="searchClick" btnCode='001P007B001' v-if="btnFlg[0]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chongZhiClick" btnCode='001P007B002' v-if="btnFlg[1]">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changeBtnClick" btnCode='001P007B003' v-if="btnFlg[2]">修改</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changeBtnClickAll" btnCode='001M0G0100' v-if="btnFlg[8]">修改</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chongTuiClick"  btnCode='001P007B004' v-if="btnFlg[3]">重推进厂</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="daoChu" btnCode='001P007B005' v-if="btnFlg[4]">导出</el-button>
        </el-form-item>
         <el-form-item>
          <el-button type="primary" @click="qiangZhiTuiSongClick" btnCode='001P007B006' v-if="btnFlg[5]">强制推送</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="appRest" btnCode='001P007B007' v-if="btnFlg[6]">APP还原</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}" v-loading='tabLoading'>
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        @row-click = 'handleRowClick'
        @current-change="handleTabCurrentChange"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column type="selection"  width="55"  align="center"></el-table-column>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
         <el-table-column prop="overrunFlag"   label="超限标记" align="center" >
            <template slot-scope="scope"><div>
              <span v-if="scope.row.overrunFlag == '0'">无</span>
              <span v-if="scope.row.overrunFlag == '1'">超</span>
            </div></template>
         </el-table-column>
        <el-table-column prop=""   label="车辆监控" width="120" align="center" >
          <template slot-scope="scope"><div>
            <el-button @click="handleHistoryClick(scope.row)" type="primary" size="small" btnCode='001P007B008' v-if="btnFlg[7] && scope.row.waybillStatus == '7'">历史轨迹</el-button>
            <el-button @click="handleAddressClick(scope.row)" type="primary" size="small" btnCode='001P007B008' v-if="btnFlg[7] && scope.row.waybillStatus != '7'">实时位置</el-button>
          </div></template>
        </el-table-column>
        <el-table-column prop="waybillNo"   label="运单编号" align="center" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="wharfSendTime" label="港口派车时间"  align="center" width="180"></el-table-column>
        <el-table-column prop="vehicleNo"    label="车牌号" align="center" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="wStatusName"  label="运单状态"  width="120" align="center"></el-table-column>
        <el-table-column prop="planNo" label="疏港计划号（单号）" align="center" width="170"></el-table-column>
        <el-table-column prop="purorderNo"    label="采购订单号" align="center" width="140"></el-table-column>
        <el-table-column prop="purplanNo"  label="采购日计划号" align="center" width="230"></el-table-column>
        <el-table-column prop="fleetName" label="车队"  align="center" width="170"></el-table-column>
        <el-table-column prop="driverName"    label="司机"  width="100" align="center"></el-table-column>
        <el-table-column prop="driverMobile" label="电话" align="center" width="140"></el-table-column>
        <el-table-column prop="goodsName"    label="物料名称" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="shipName"  label="船名" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="wharfName" label="港口"  align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="wharfxName" label="码头"  align="center" ></el-table-column>
        <el-table-column prop="areaName"    label="码头场区"  width="100" align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="stackPosition" label="码头垛位" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="warehouseName"    label="收货仓库" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="locationName"  label="收货库位" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="sfirstTare" label="港口一检皮重"  align="center" width="160" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.sfirstTare == undefined || scope.row.sfirstTare == null || scope.row.sfirstTare == ''">-</span>
            <span v-else>{{scope.row.sfirstTare.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="sgrossWeight"  label="港口二检毛重" align="center" width="160" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.sgrossWeight == undefined || scope.row.sgrossWeight == null || scope.row.sgrossWeight == ''">-</span>
            <span v-else>{{scope.row.sgrossWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="ssuttle" label="港口出货净重"  align="center" width="160" >
          <template slot-scope="scope"><div>
            <span v-if="scope.row.ssuttle == undefined || scope.row.ssuttle == null || scope.row.ssuttle == ''">-</span>
            <span v-else>{{scope.row.ssuttle.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="efirstTare" label="进厂一检毛重"  align="center" width="160" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.efirstTare == undefined || scope.row.efirstTare == null || scope.row.efirstTare == ''">-</span>
            <span v-else>{{scope.row.efirstTare.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="egrossWeight"    label="出厂二检皮重"  width="150" align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="esuttle" label="进厂货物净重" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="grossErrorRate"    label="毛重误差率（‰）" align="center" width="140" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="netErrorRate"  label="净重误差率（‰）" align="center" width="140" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="sbTime" label="司机上报时间"  align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="wharfSendUser" label="派车人"  align="center" width="150" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="wharfOutTime" label="出港过磅时间"  align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="plantInTime"    label="进厂过磅时间"  width="180" align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="plantOutTime" label="出厂过磅时间" align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="finishTime"    label="司机完成时间" align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="wharfCancelTime"  label="撤销时间" align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div >
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!--历史轨迹-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="historicalTrack"
    @close="closeDialog" @opened="openedDialog"
    width="900px"
    center>
    <div v-loading="mapLoading">
      <span>
        <div class="mapBox">
          <div class="map" id="map"></div>
        </div>
        <el-table
        :data="tableData"
        ref="tableData"
        border
        bordersize="mini"
        height="300"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <!-- <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column> -->
        <el-table-column prop="reportTime"   label="上报时间" align="center"  ></el-table-column>
        <el-table-column property="address" label="当前位置"  align="center" ></el-table-column>
        <el-table-column prop="speed"    label="当前速度" align="center" ></el-table-column>
        <el-table-column prop="direction"    label="当前方向"   align="center"></el-table-column>
        <el-table-column prop="lon" label="经度" align="center" ></el-table-column>
        <el-table-column prop="lat"    label="纬度" align="center" ></el-table-column>
      </el-table>
      </span>
      <div style="width:60px;margin:15px auto;">
        <el-button @click="historicalTrack = false" size='mini'>关闭</el-button>
      </div>
      </div>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="changeMrack"
    @close="changeGB"
    width="500px"
    center>
      <div style="width:80%; margin:15px auto;" v-loading="changeLoading">
        <span>
          <el-form :rules="rules" :model="changeFrom" ref="changeFrom" class="demo-form-inline" label-width="120px" size="mini">
            <el-form-item label="港口一检皮重:" prop="sfirstTare">
              <el-input  placeholder="" v-number-input.float="3" maxlength="10" v-model="changeFrom.sfirstTare" style="width:190px;" @blur="inputFun"></el-input>
              <span style="margin-left:5px;color:red;font-weight:600;">吨</span>
            </el-form-item>
            <el-form-item label="港口二检毛重:" prop="sgrossWeight" style="margin-top:20px;">
              <el-input  placeholder="" v-number-input.float="3" maxlength="10" v-model="changeFrom.sgrossWeight" style="width:190px;" @blur="inputFunB"></el-input>
              <span style="margin-left:5px;color:red;font-weight:600;">吨</span>
            </el-form-item>
            <el-form-item label="出港过磅时间:" prop="wharfOutTime" style="margin-top:20px;" v-if="changeAllFlag == false">
              <el-date-picker
                v-model="changeFrom.wharfOutTime"
                size="mini"
                style="width: 190px"
                placeholder="选择日期"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="出港过磅时间:" prop="wharfOutTime" style="margin-top:20px;" v-if="changeAllFlag == true">
              <el-date-picker
                v-model="changeFrom.wharfOutTime"
                size="mini"
                style="width: 190px"
                placeholder="选择日期"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <!-- 2022-06-22 韦苗苗改  只有实施人员可以修改运单状态 -->
            <el-form-item label="运单状态:" prop="waybillStatus" style="margin-top:20px;" v-if="changeAllFlag">
              <el-select v-model="changeFrom.waybillStatus" placeholder="请选择">
                <el-option
                  v-for="(item,index) in waybillStatusOptions"
                  :key="index"
                  :label="item.showName"
                  :value="item.itemNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上传过磅小票:" style="margin-top:20px;" class="is-required">
              <div class="box" v-if="changeMrack">
                <div class="imgBox">
                  <uploadImgs :imgList.sync='imgYY'></uploadImgs>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </span>
        <div style="margin:15px auto;width:160px;">
          <el-button type="primary" size='mini' @click="changeOk('changeFrom')">修改</el-button>
          <el-button @click="changeGB" size='mini'>关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 实时位置 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="addressTrack"
    @close="closeDialog2" @opened="openedDialog2"
    width="900px"
    center>
    <div v-loading="mapLoading2">
      <span>
        <div class="mapBox">
          <div class="map" id="map1"></div>
        </div>
      </span>
      <div style="width:60px;margin:15px auto;">
        <el-button @click="addressTrack = false" size='mini'>关闭</el-button>
      </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  fleetList,
  getAllWaybillList, // 列表
  getDictionaryList, // 字典
  saveWaybill, // 修改
  getZhbWayweightListWbNo, // 重推进厂
  enforcementBytWaybillQuery, // 强制推送
  getVehicleHistory, // 历史轨迹
  getPoiDetail, // 历史轨迹列表
  bPlantInfoList, // 收货仓库
  getPortOptions, // 获取港口的下拉列表
  appRest, // App重置
  getVehicleAddress, // 实时位置
  getWayBillWharfWeight // 获取磅单图片
} from '@/api/zhb-sgHarbour'
import { getBtn } from '@/utils/getButton'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import AMap from 'AMap'
import DonMessage from '@/utils/message'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
import uploadImgs from '@/components/uploadImgs.vue'
import { compressImages } from '@/utils/compressImages'
export default {
  components: {
    uploadImgs
  },
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnIdArr: ['001P007B001', '001P007B002', '001P007B003',
        '001P007B004', '001P007B005', '001P007B006',
        '001P007B007', '001P007B008', '001M0G0100'],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10,
        fleetId: '',
        wharfId: '',
        wharfxId: '',
        warehouseName: '',
        waybillStatus: '',
        overrunFlag: '',
        startTime: '',
        endTime: ''
      },
      // 港口
      portOptions: [],
      // 码头
      wharfOptions: [],
      // 运单状态
      waybillStatusOptions: [],
      // 超限标记
      overrunMarkOptions: [
        {
          showName: '全部',
          itemNo: ''
        },
        {
          showName: '无',
          itemNo: '0'
        },
        {
          showName: '超',
          itemNo: '1'
        }
      ],
      // 收货仓库
      receivingWarehouseOptions: [],
      // 车队
      fleetOptions: [],
      value: '',
      tableList: [],
      // 新增
      addShengChengLoading: false,
      addFaBuLoading: false,
      // 修改
      changeFlag: '', // 1自动  2 手动
      changeData: {}, // 修改需携带的数据
      faBuId: '',
      planStatus: '',
      // 历史轨迹
      historicalTrack: false,
      marker: null,
      map: null,
      lngLat: [],
      vehicleNo: '',
      sbTime: '',
      endTime: '',
      // 历史轨迹列表
      tableData: [],
      // 修改
      changeMrack: false,
      changeFrom: {
        waybillId: '',
        sfirstTare: '',
        sgrossWeight: '',
        wharfOutTime: ''
      },
      changeLoading: false,
      tabLoading: false,
      mapLoading: false,
      // 实时位置
      addressTrack: false,
      mapLoading2: false,
      marker2: null,
      map2: null,
      addressStartLngAngLat: [],
      addressEndLngAngLat: [],
      addressArr: [],
      markerContent: '',
      changeAllFlag: false,
      tabList: [],
      imgList: [],
      dialogImageUrl: '',
      isAddImg: false,
      dialogVisible: false,
      delFlag: false,
      rules: {
        sfirstTare: [
          { required: true, message: '请输入港口一检皮重', trigger: 'blur' }
        ],
        sgrossWeight: [
          { required: true, message: '请输入港口二检毛重', trigger: 'blur' }
        ]
      },
      imgYY: [],
      pickerOptions: {
        disabledDate (v) {
        // 1、日期禁止选择今天以前的日期
          // return v.getTime() < new Date().getTime() - 86400000
          // 2、日期禁止选择今天之后的日期
          // return v.getTime() > Date.now()
          // 3、日期限制只能选当天、昨天、前天
		      let limitDate = v.getTime() < new Date().getTime() - 3 * 86400000 || v.getTime() >= Date.now()
		      // 86400000:一天的毫秒
		      return limitDate
        }
      }
    }
  },
  filters: {
    rounding (value) {
      return value.toFixed(3)
    }
  },
  created () {
    this.getToDay()
    this.initPortOption()
    this.fleetOptionsInit()
    this.getSeatchData(this.searchFrom)
    this.getDictionaryList()
    this.bPlantInfoList()
    this.btnFlg = getBtn(this.btnIdArr, '/sgWaybill/waybillSearch')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 100) + 'px'
  },
  methods: {
    // 港口下拉框列表
    initPortOption () {
      getPortOptions().then(res => {
        this.portOptions = res
      }).catch(err => {
        console.log(err)
        this.$message.error('获取港口下拉列表失败')
      })
    },
    fleetOptionsInit () {
      fleetList().then(res => {
        this.fleetOptions = res
        this.fleetOptions.unshift({ 'fleet': '', 'fleetName': '全部' })
      })
    },
    wharfxIdChange () {
      this.$forceUpdate()
    },
    // 字典
    getDictionaryList () {
      getDictionaryList({
        groupNo: 'wharf,wharf_1,waybill_status,basic_point'
      }).then(res => {
        // this.portOptions = res.wharf   // 港口
        // this.portOptions.unshift({'itemNo':'','showName':'全部'})
        // this.wharfOptions = res.wharf_1  // 码头
        // this.wharfOptions.unshift({'itemNo':'','showName':'全部'})
        this.waybillStatusOptions = res.waybill_status // 运单状态
        this.waybillStatusOptions.unshift({ 'itemNo': '', 'showName': '全部' })
        this.addressStartLngAngLat = []
        if (res.basic_point.length != 0) {
          this.addressStartLngAngLat.push(res.basic_point[1].showName2, res.basic_point[1].showName3)
          this.addressEndLngAngLat = []
          this.addressEndLngAngLat.push(res.basic_point[0].showName2, res.basic_point[0].showName3)
          console.log(this.addressStartLngAngLat, 'this.addressStartLngAngLat')
          console.log(this.addressEndLngAngLat, 'this.addressEndLngAngLat')
        }
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    portOptionChangeDialog (item) {
      if (item != null && item != undefined && item != '') {
        this.searchFrom.wharfxName = ''
        for (let index = 0; index < this.portOptions.length; index++) {
          let element = this.portOptions[index]
          if (element.itemNo == item) {
            this.wharfOptions = element.portList
            return
          }
        }
      }
    },
    // 收货仓库
    bPlantInfoList () {
      bPlantInfoList().then(res => {
        this.receivingWarehouseOptions = res // 收货仓库
        this.receivingWarehouseOptions.unshift({ 'plantId': '', 'plantName': '全部' })
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 年月日格式化
    timeStamp: function (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log('time:' + JSON.stringify(now))
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    // 日期格式化
    getCurrentTime () {
      let date = new Date()
      let Y = date.getFullYear()
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let D = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes()
      let seconds = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds()
      date = Y + '-' + M + '-' + D + ' ' + hours + ':' + minutes + ':' + seconds
      // console.log(date)  							// 2019-10-12 15:19:28
      return date
    },
    timeStamp2: function (value) { // 具体到时分秒
      var date = new Date(value) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var sdate = ('0' + date.getDate()).slice(-2)
      var hour = ('0' + date.getHours()).slice(-2)
      var minute = ('0' + date.getMinutes()).slice(-2)
      var second = ('0' + date.getSeconds()).slice(-2)
      // 拼接
      var result = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute + ':' + second
      // 返回
      return result
    },
    // 时间改变
    startTimeChangeA () {
      this.searchFrom.startTime = this.timeStamp2(this.searchFrom.startTime)
    },
    // 时间改变
    startTimeChangeB () {
      this.searchFrom.endTime = this.timeStamp2(this.searchFrom.endTime)
    },
    // 计划开始时间-当前日期早8点
    getToDay () {
      // 早八点之前显示昨天的日期，早八点之后显示今天的日期
      let dateStartStr = this.timeStamp2(new Date(new Date(new Date().toLocaleDateString()).getTime() + 28800000)) // 当天的早8点时间戳
      // console.log((new Date()).getTime(),'22222')  //当前时间戳
      let nowDate = (new Date()).getTime()
      // console.log(this.timeStamp2(new Date(dateStartStr).getTime()-86400000),'333')   // 早八点时间戳
      let morningTime = new Date(dateStartStr).getTime()
      if (nowDate > morningTime) { // 86400000 1天的毫秒
        this.searchFrom.startTime = this.timeStamp2(new Date(dateStartStr).getTime())
        this.searchFrom.endTime = this.timeStamp2(new Date(dateStartStr).getTime() + 86400000)
        // console.log(this.searchFrom.endTime, 'this.searchFrom.endTime.......')
      } else {
        // 昨天的时间
        this.searchFrom.startTime = this.timeStamp2(new Date(dateStartStr).getTime() - 86400000)
        this.searchFrom.endTime = this.timeStamp2(new Date(dateStartStr).getTime())
        // console.log(this.searchFrom.endTime, 'this.searchFrom.endTime')
      }
    },
    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      getAllWaybillList(this.searchFrom).then(res => {
        this.tabLoading = false
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        this.tabLoading = false
        // console.log(err.message)
        this.$message.error(err.message)
      })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData(this.searchFrom)
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10,
        fleetId: '',
        wharfName: '',
        wharfxName: '',
        warehouseName: '',
        waybillStatus: '',
        overrunFlag: '',
        startTime: '',
        endTime: ''
      }
      this.getToDay()
      this.getSeatchData(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row) {
      // console.log(row)
      this.$refs.tableRef.toggleRowSelection(row)
      this.changeFlag = row.newFlg
      this.changeData = row
      this.faBuId = row.id
      this.planStatus = row.planStatus
    },
    getWayBillWharfWeight (params) {
      getWayBillWharfWeight(params.waybillId).then(res => {
        this.$set(this.changeFrom, 'waybillId', res.waybillId)
        this.$set(this.changeFrom, 'sfirstTare', res.sfirstTare)
        this.$set(this.changeFrom, 'sgrossWeight', res.sgrossWeight)
        if (res.wharfOutTime) {
          this.$set(this.changeFrom, 'wharfOutTime', this.timeStamp2(res.wharfOutTime))
        }
        this.$set(this.changeFrom, 'waybillStatus', res.waybillStatus)
        if (res.filePath) {
          this.$set(this.imgYY, 0, { status: 'ready', url: res.filePath, isEdit: true })
        }
        this.changeMrack = true
        this.title = '修改信息'
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击修改按钮
    changeBtnClick (row) {
      this.changeAllFlag = false
      let selectData = this.$refs.tableRef.selection
      console.log(selectData, '...')
      if (selectData.length < 1) {
        this.$message.error('请选择一条数据进行操作')
      } else if (selectData.length > 1) {
        this.$message.error('只能选择一条数据进行修改！')
      } else {
        // 2022.05.19 韦苗苗改
        // 1、运单状态是2、4、44、52、9 的时候，都可以修改运单
        // 2、重推进厂和强制进厂2个按钮，判断运单表的ssuttle必须有数值的情况下（不能为空，也不能为0），才能点击
        if (selectData[0].waybillStatus == '2' ||
            selectData[0].waybillStatus == '4' ||
            selectData[0].waybillStatus == '44' ||
            selectData[0].waybillStatus == '52' ||
            selectData[0].waybillStatus == '9') {
          this.getWayBillWharfWeight(selectData[0])
        } else {
          // this.$message.error('只能修改港口已派车或二检完成数据！')
          this.$message.error('该状态数据不能修改！')
        }
      }
    },
    // 2022.08.02 韦苗苗改  皮重毛重只能输入到十位数
    inputFun () {
      if (this.changeFrom.sfirstTare > 100) {
        this.$message.error('请核对之后再输入皮重（单位：吨）')
      }
    },
    inputFunB () {
      if (this.changeFrom.sgrossWeight > 100) {
        this.$message.error('请核对之后再输入毛重（单位：吨）')
      }
    },
    changeBtnClickAll () {
      this.changeAllFlag = true
      let selectData = this.$refs.tableRef.selection
      console.log(selectData, '...')
      // 2022-06-20 韦苗苗改 任何状态都能修改  这个按钮只能放给实施人员
      if (selectData.length < 1) {
        this.$message.error('请选择一条数据进行操作')
      } else if (selectData.length > 1) {
        this.$message.error('只能选择一条数据进行修改！')
      } else {
        this.getWayBillWharfWeight(selectData[0])
      }
    },
    // 点击修改确定
    changeOk () {
      // 毛重必须大于皮重  sgrossWeight > sfirstTare // 2022.05.25 韦苗苗改
      this.$refs.changeFrom.validate((valid) => {
        if (valid) {
          if (this.changeFrom.sgrossWeight <= this.changeFrom.sfirstTare) {
            this.$message.error('毛重必须大于皮重')
          } else {
            if (this.changeFrom.sfirstTare > 100) {
              this.$message.error('请核对之后再输入皮重（单位：吨）')
            } else if (this.changeFrom.sgrossWeight > 100) {
              this.$message.error('请核对之后再输入毛重（单位：吨）')
            } else {
              let imgfile = new FormData()
              let imgList = []
              if (this.imgYY.length == 0) {
                this.$alert('请上传过磅小票', '系统提示')
                return
              }
              if (this.imgYY.length > 0 && !this.imgYY[0].isEdit) {
                imgList[0] = this.imgYY[0]
              } else if (this.imgYY.length > 0 && this.imgYY[0].isEdit) {
                imgList[0] = null
              }
              console.log(this.imgYY, 'this.imgYY')
              imgfile.set('params', JSON.stringify(this.changeFrom))
              compressImages(imgList, {
                width: 1000
              }).then(result => {
                console.log(result[0], 'result')
                imgfile.set('file', result[0])
                this.saveWaybill(imgfile)
              })
            }
          }
        } else {
          return false
        }
      })
    },
    saveWaybill (imgfile) {
      this.changeLoading = true
      saveWaybill(imgfile).then(res => {
        this.changeLoading = false
        this.$message.success('修改成功！')
        this.changeMrack = false
        this.getSeatchData(this.searchFrom)
      }).catch(err => {
        this.changeLoading = false
        this.$message.error(err.message)
      })
    },
    changeGB () {
      this.changeFrom = {
      }
      this.imgYY = []
      this.changeMrack = false
      if (this.$refs.changeFrom) {
        this.$refs.changeFrom.clearValidate()
      }
    },
    // 重推进厂
    chongTuiClick (row) {
      let selectData = this.$refs.tableRef.selection
      if (selectData.length < 1) {
        this.$message.error('请选择一条数据进行操作')
      } else if (selectData.length > 1) {
        this.$message.error('只能选择一条数据进行修改！')
      } else {
        getZhbWayweightListWbNo({
          waybillNo: selectData[0].waybillNo
        }).then(res => {
          console.log(res)
          if (res.result == '2') {
            this.$message.error('当前所选运单的状态不能进行计量委托！')
          } else {
            this.$message.success('重推进厂成功！')
            this.getSeatchData(this.searchFrom)
          }
        }).catch(err => {
          this.$message.error(err.message)
        })
      }
    },
    // 强制推送
    qiangZhiTuiSongClick () {
      let selectData = this.$refs.tableRef.selection
      if (selectData.length < 1) {
        this.$message.error('请选择一条数据进行操作')
      } else if (selectData.length > 1) {
        this.$message.error('只能选择一条数据进行操作！')
      } else {
        enforcementBytWaybillQuery({
          waybillNo: selectData[0].waybillNo
        }).then(res => {
          console.log(res)
          if (res.result == '2') {
            this.$message.error('当前所选运单的状态不能进行计量委托！')
          } else {
            this.$message.success('强制推送成功！')
            this.getSeatchData(this.searchFrom)
          }
        }).catch(err => {
          this.$message.error(err.message)
        })
      }
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 点击历史轨迹
    handleHistoryClick (row) {
      if (this.marker) {
        this.map.clearMap()
      }
      this.title = '历史轨迹'
      this.endTime = row.endTime
      let updateTime = row.updateTime
      this.vehicleNo = row.vehicleNo
      this.sbTime = row.sbTime
      if (this.endTime == undefined && updateTime == undefined) {
        this.$message.error('任务完成时间与司机完成时间均为空，无法查询轨迹！')
      } else if (this.endTime == undefined) {
        this.endTime = updateTime
        this.historicalTrack = true
        this.getVehicleHistory()
        this.getPoiDetail()
      }
    },
    getVehicleHistory () {
      this.mapLoading = true
      getVehicleHistory({
        vehicleNo: this.vehicleNo,
        excepStart: this.sbTime,
        excepEnd: this.endTime
      }).then(res => {
        this.mapLoading = false
        this.lngLat = res
        this.initMap()
        this.polylineFn()
      }).catch(err => {
        this.mapLoading = false
        this.$message.error(err.message)
      })
    },
    getPoiDetail () {
      // 列表
      getPoiDetail({
        vehicleNo: this.vehicleNo,
        excepStart: this.sbTime,
        excepEnd: this.endTime
      }).then(res => {
        this.tableData = res.rows
        // console.log(res.rows)
        // 北方向
        this.tableData.forEach((item, index) => {
          if (item.direction >= 0 && item.direction <= 22 || item.direction >= 338 && item.direction <= 360) {
            item.direction = '北'
          }
          // 东北方向
          if (item.direction >= 23 && item.direction <= 67) {
            item.direction = '东北'
          }
          // 东方向
          if (item.direction >= 68 && item.direction <= 112) {
            item.direction = '东'
          }
          // 东南方向
          if (item.direction >= 113 && item.direction <= 157) {
            item.direction = '东南'
          }
          // 南方向
          if (item.direction >= 158 && item.direction <= 202) {
            item.direction = '南'
          }
          // 西南方向
          if (item.direction >= 203 && item.direction <= 247) {
            item.direction = '西南'
          }
          // 西方向
          if (item.direction >= 248 && item.direction <= 292) {
            item.direction = '西'
          }
          // 西北方向
          if (item.direction >= 293 && item.direction <= 337) {
            item.direction = '西北'
          }
        })
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 打开弹框
    openedDialog () {
      // this.initMap()
      // if (!this.isAddImg) {
      //   let marker = new AMap.Marker({
      //     position: [this.lngLat[0], this.lngLat[this.lngLat.length - 1]]
      //   })
      //   // 将创建的点标记添加到已有的地图实例：
      //   this.map.add(marker)
      // }
      // this.polylineFn()
    },
    closeDialog () {
    },
    // 地图
    initMap () {
      this.map = new AMap.Map('map', {
        center: this.lngLat[0], // [纬度，经度]
        resizeEnable: true,
        zoom: 12
      })
    },
    polylineFn () {
      console.log(this.lngLat[0], '...')
      this.marker = new AMap.Marker({
        map: this.map,
        position: this.lngLat[0],
        icon: new AMap.Icon({
          image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/zhbcps/Applets/qi.png',
          size: new AMap.Size(30, 30), // 图标大小
          imageSize: new AMap.Size(30, 30),
          offset: new AMap.Pixel(-10, -34)
        }),
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      this.marker = new AMap.Marker({
        map: this.map,
        position: this.lngLat[this.lngLat.length - 1],
        icon: new AMap.Icon({
          image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/zhbcps/Applets/zhong.png',
          size: new AMap.Size(30, 30), // 图标大小
          imageSize: new AMap.Size(30, 30),
          offset: new AMap.Pixel(-10, -34)
        }),
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      var passedPolyline = new AMap.Polyline({
        map: this.map,
        path: this.lngLat,
        strokeColor: '#2d70e4', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 3, // 线宽
        strokeStyle: 'solid' // 线样式
      })
      this.marker.on('moving', function (e) {
        passedPolyline.setPath(e.passedPath)
      })
      this.map.setFitView()
    },
    daoChu () {
      if (this.total > 10000) {
        this.$message.error('导出不能超过10000条数据')
      } else {
        this.$confirm('是否进行此操作？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          closeOnClickModal: false,
          type: 'warning'
        })
          .then(() => {
            exportExcel(
              '/zw56-zhb-ess-server/zhbess/waybill/exportWayBillListInExcel',
              this.searchFrom,
              '运单列表'
            )
          })
          .catch(() => {})
      }
    },
    // App重置
    appRest () {
      // let selectData = this.$refs.tableRef.selection
      // if (selectData.length < 1) {
      //   this.$message.error('请选择一条数据进行操作')
      // } else if (selectData.length > 1) {
      //   this.$message.error('只能选择一条数据进行操作！')
      // } else if(selectData[0].wStatusName != '任务已完成'){
      //   this.$confirm('是否进行APP还原，还原后正在进行的任务将被强制完成？', '提示', {
      //     confirmButtonText: '是',
      //     cancelButtonText: '否',
      //     closeOnClickModal: false,
      //     type: 'warning'
      //   })
      //   .then(() => {
      //     let vehicleNo = selectData[0].vehicleNo
      //     appRest(vehicleNo).then(res =>{
      //       this.$message.success('重置成功！')
      //       this.getSeatchData(this.searchFrom)
      //     }).catch(err =>{
      //       this.$message.error(err.message)
      //     })
      //   })
      //   .catch(() => {})
      // }else{
      //   this.$message.error('此状态不能重置')
      // }

      let selectData = this.$refs.tableRef.selection
      if (selectData.length < 1) {
        this.$message.error('请选择一条数据进行操作')
      } else if (selectData.length > 1) {
        this.$message.error('只能选择一条数据进行操作！')
      } else {
        this.$confirm('是否进行APP还原，还原后正在进行的任务将被强制完成？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          closeOnClickModal: false,
          type: 'warning'
        })
          .then(() => {
            let vehicleNo = selectData[0].vehicleNo
            appRest(vehicleNo).then(res => {
              this.$message.success('重置成功！')
              this.getSeatchData(this.searchFrom)
            }).catch(err => {
              this.$message.error(err.message)
            })
          })
          .catch(() => {})
      }
    },
    // 实时位置
    handleAddressClick (row) {
      this.addressTrack = true
      this.title = '实时位置'
      this.vehicleNo = row.vehicleNo
      this.mapLoading2 = true
      this.getVehicleAddress()
    },
    getVehicleAddress () {
      getVehicleAddress({
        vehicleNo: this.vehicleNo
      }).then(res => {
        this.mapLoading2 = false
        this.addressArr = []
        this.addressArr.push(res.longitude, res.latitude)
        this.markerContent = res.vehicleNo
        this.initMap2()
        this.markerOption()
      }).catch(err => {
        this.mapLoading2 = false
        this.$message.error(err.message)
      })
    },
    // 地图
    initMap2 () {
      this.map2 = new AMap.Map('map1', {
        center: this.addressStartLngAngLat, // [纬度，经度]
        resizeEnable: true,
        zoom: 12
      })
      // this.map2.setFitView()
      this.drawMap()
      // this.markerOption()
    },
    markerOption () {
      if (this.marker2) {
        this.map2.clearMap()
      }
      let icon = null
      let marker
      console.log(this.addressArr, 'vhcLat')
      icon = new AMap.Icon({
        image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/zhbcps/Applets/daipaiche.png',
        size: new AMap.Size(25, 25), // 图标大小
        imageSize: new AMap.Size(25, 15)
      })
      marker = new AMap.Marker({
        position: new AMap.LngLat(this.addressArr[0], this.addressArr[1]), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        icon: icon
      })
      marker.content = this.markerContent
      // console.log(item,'item')
      marker.emit('click', { target: marker })
      marker.setMap(this.map2)
      marker.on('click', this.markerClick)
      this.map2.setFitView()
    },
    markerClick (e) {
      // console.log(e, '11111')
      this.infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -30) })
      this.infoWindow.setContent(e.target.content)
      this.infoWindow.open(this.map2, e.target.getPosition())
    },
    drawMap () {
      let that = this
      that.map2 = new AMap.Map('map1', {
        center: that.addressStartLngAngLat, // [纬度，经度]
        resizeEnable: true,
        zoom: 12
      })
      AMap.plugin('AMap.Driving', function () {
        var driving = new AMap.Driving({
          // 驾车路线规划策略，AMap.DrivingPolicy.LEAST_TIME是最快捷模式,还有其他几种方式见Api文档
          policy: 1
        })
        // 起、终点
        var start_xy = new AMap.LngLat(that.addressStartLngAngLat[0], that.addressStartLngAngLat[1]) // 起点的经纬度
        var end_xy = new AMap.LngLat(that.addressEndLngAngLat[0], that.addressEndLngAngLat[1]) // 终点的经纬度
        // 根据起终点经纬度规划驾车导航路线
        driving.search(start_xy, end_xy, function (status, result) {
          console.log(result, 'result')
          if (status === 'complete') {
            if (result.routes && result.routes.length) {
              console.log(result.routes[0])
              // 绘制第一条路线，也可以按需求绘制其它几条路线
              var path = that.parseRouteToPath(result.routes[0])
              var startMarker = new AMap.Marker({
                position: path[0],
                icon: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/zhbcps/Applets/qi.png',
                map: that.map2
              })
              var endMarker = new AMap.Marker({
                position: path[path.length - 1],
                icon: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/zhbcps/Applets/zhong.png',
                map: that.map2
              })
              var routeLine = new AMap.Polyline({
                path: path,
                isOutline: true,
                outlineColor: '#ffeeee',
                borderWeight: 2,
                strokeWeight: 5,
                strokeColor: '#0091ff',
                lineJoin: 'round'
              })
              routeLine.setMap(that.map2)

              // 调整视野达到最佳显示区域
              that.map2.setFitView([ startMarker, endMarker, routeLine ])
              console.log('绘制驾车路线完成')
            }
          } else {
            console.log('获取驾车数据失败：' + result)
          }
        })
      })
    },
    parseRouteToPath (route) {
      var path = []
      for (var i = 0, l = route.steps.length; i < l; i++) {
        var step = route.steps[i]
        for (var j = 0, n = step.path.length; j < n; j++) {
          path.push(step.path[j])
        }
      }
      return path
    },
    closeDialog2 () {
    },
    // 打开弹框
    openedDialog2 () {
      // this.initMap2()
    }
  }
}
</script>
<style scoped lang='less'>
.el-table{
overflow:visible !important;
}
.searchBox{
  margin-left: 25px;
}
.inpBox{
  margin: 10px 0 0 -30px;
}

//  /deep/ .inpBox .el-range-editor--mini .el-input__inner {
//    width: 150px;
// }
// .inpBox .el-date-editor{
//     width: 280px!important;
//  }
.searchBtnBox{
  margin-top: 10px;
  margin-left: -20px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
.tongJi{
  display: flex;
  margin-left:10px;
}
.tongJi_item{
  margin-right: 20px;
}
.tongJi_item span{
  color: red;
}
.mapBox{
  width: 100%;
  height: 560px;
  position: relative;
}
.map{
  width: 100%;
  height: 100%;
}
.box{
  margin-top:-10px;
  // width: 100px;
  // width: 500px;
  // display: flex;
  // justify-content: space-around;
  // flex-wrap:wrap;
  .imgBox{
    display: flex;
    flex-direction: column;
    width: 100px;
    /deep/.el-upload--picture-card{
      width: 100px;
      height: 100px;
    }
    span{
      text-align: center;
    }
  }
  .hidden /deep/.el-upload--picture-card{
    display: none;
  }
  /deep/.el-upload--picture-card {
    background-image: url(../../../../assets/images/upload2.png);
    // background-size:180px 100px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
    width: 100px;
    height: 100px;
  }
}
.imgDialog /deep/.el-dialog__body{
  text-align: center;
}
</style>
